import { render, staticRenderFns } from "./BimDatabank.vue.html?vue&type=template&id=3a947eca&scoped=true&lang=html&external"
import script from "./BimDatabank.vue.js?vue&type=script&lang=js&external"
export * from "./BimDatabank.vue.js?vue&type=script&lang=js&external"
import style0 from "./BimDatabank.vue.scss?vue&type=style&index=0&id=3a947eca&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a947eca",
  null
  
)

export default component.exports